import { render, staticRenderFns } from "./CompanyCategories.vue?vue&type=template&id=da48358e&"
import script from "./CompanyCategories.vue?vue&type=script&lang=js&"
export * from "./CompanyCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports